import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService, FeatureToggleService, LoaderService } from '@agenda-customer-ui/data-access';
import { ITokens, IUrlInfo } from '@core/interface';
import { TranslateService } from '@ngx-translate/core';
import { getSourceCode } from '@core/utils';
import { firstValueFrom } from 'rxjs';
import { Source } from '../../enums/Source.enum';
import { getLangByCountry } from '../../utils/utils';
import { AppMaintenancePageComponent } from '../../components/app-maintenance/app-maintenance.component';
import { HistoryMainContainerComponent } from './main-container/main-container-history.component';
import { Router } from '@angular/router';

@Component({
  selector: 'agenda-customer-ui-history-project',
  styleUrls: ['./history.component.scss'],
  templateUrl: './history.component.html',
  standalone: true,
  imports: [CommonModule, AppMaintenancePageComponent, HistoryMainContainerComponent],
  providers: [AuthService, LoaderService, FeatureToggleService, TranslateService]
})
export class HistoryProjectComponent implements OnInit {
  #tokens!: ITokens;
  #urlInfo!: IUrlInfo;

  language!: string;
  showProject = true;

  constructor(
    private auth: AuthService,
    private translate: TranslateService,
    private loaderService: LoaderService,
    private featureToggle: FeatureToggleService,
    private router: Router
  ) { }

  ngOnInit() {
    this.auth.setParameters().subscribe(async param => {
      this.#tokens = {
        cat: param['cat'] || param['token']
      };

      const country = param['country'];
      const source = param['source']

      if (!country || !source) {
        return;
      }

      this.#urlInfo = {
        source,
        country,
        vin: param['vin']
      };

      this.auth.tokens = this.#tokens;
      this.auth.urlInfo = this.#urlInfo;

      this.getLang(country || '');

      this.setScheduleSourceInStorage(source);
      try {
        this.showProject = (await firstValueFrom(this.featureToggle.getList(country))).OSR_FLOW_DISPLAY_HISTORY?.active || false;
        localStorage.setItem('maintenanceWindow', `${!this.showProject}`);
      } catch (error) {
        console.error('Error fetching feature toggle:', error);
        this.showProject = false;
        localStorage.setItem('maintenanceWindow', 'true');
      }

      if (!this.showProject) {
        this.router.navigate(['/maintenance']);
        return;
      }

      this.loaderService.isLoadingParams.next(false)
    });
  }

  setScheduleSourceInStorage(source: string) {
    if (!source) {
      return;
    }

    const sourceCode = getSourceCode(source);
    sessionStorage.setItem('scheduleSource', sourceCode || Source.web);
  }

  getLang(country: string) {
    sessionStorage.setItem('country', country);
    const tempLang = sessionStorage.getItem('tempLang');
    this.language = getLangByCountry(country || '');

    if (tempLang) {
      this.language = tempLang;
    }

    this.translate.setDefaultLang(this.language);
    this.translate.use(this.language);
  }
}
